var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticStyle:{"background-color":"whitesmoke","height":"78vh"},attrs:{"justify":"center"}},[_vm._v(" Numpad ")])
}
var staticRenderFns = []

export { render, staticRenderFns }